import React, { Component } from "react";
import Retefuente from "../../../components/Retefuente/Retefuente";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : RegisterForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se llama al componente Resgister
================================================================================ */

class RetefuenteForm extends Component {
    render() {
        return (
            <Retefuente />
        )
    }
}

export default RetefuenteForm;